<template>
<div v-if="readyInterval==-1" class="row range" :class="{'value-127':this.value==-127,'value-9':this.value==-9,'value-ok':this.value!=-9 && this.value!=-127,'nc-false':item.nr!=-127}">
   <div v-if="item.nr==-127" class="col yo-align-left"  :class="{s4: this.nc==1,s12: this.nc<1}">
      <el-select v-model="nc" placeholder="Selezionare" v-on:change="ncChange" v-on:input="ncChange"  clearable>
         <!-- <el-option label="Selezionare" :value="0" ></el-option> -->
         <el-option label="Conosciuto" :value="1" ></el-option>
         <el-option v-if="item.nc!=0" label="Non Conosciuto" :value="-1" ></el-option>
      </el-select>
   </div>
   <div class="col yo-align-right" :class="{s8: item.nr!=0,s12: item.nr==0}">
      <el-input-number v-if="(nc == 1) && value<=answer.max && value>=answer.min" v-bind:value.sync="value" :precision="answer.precision" :step="answer.step"    v-on:input="updateValue"></el-input-number>
      <div v-if="nc==1 && (answer.max<value || value<answer.min)" class="yo-align-center" style="color:red;">Il valore è fuori da quelli consentiti!</div>
   </div>
     <!-- {{valueLast}} :: {{value}} :: {{nc}} :: {{answer.max}} -->
   </div>
</template>

<script>
export default {
      name: 'FormRange',
      model: {
      // By default, `v-model` reacts to the `input`
      // event for updating the value, we change this
      // to `change` for similar behavior as the
      // native `<select>` element.
      event: 'change',
   },
   data() {
      return {
         readyInterval:0
         ,nc: ''
         ,valueLast: this.value
      }
   },
   watch: {
      value: function(val){
         console.log("THIS.VALUE is now "+val)
         this.action4value(val)
         
       
      }
   },
   props: ['value','variabile'],
   created () {
      console.log("Created form for variable "+this.variabile)

      this.readyInterval = setInterval(() => { 
         console.log("Before action4value form for "+this.variabile+" the values is "+this.value +' and nc '+this.nc)
         if(typeof this.value != 'undefined' && this.value !==''){
            if(this.value==-7)
               this.value=-127
            if(this.item.nc==0 && this.value!=-127)
               this.nc=1
            
            this.action4value(this.value)
            console.log("After action4value form for "+this.variabile+" the values is "+this.value +' and nc '+this.nc)

            if((this.value>this.answer.max || this.value<this.answer.min) && (this.nc==1)){
                  console.log("THIS.VALUE is out of range need to be set to "+this.valueLast)
                        this.$emit('change',this.answer.min)
            }
            clearInterval(this.readyInterval)
            this.readyInterval = -1
            this.$emit('change', this.value)
         }
      }, 1000)


      
   },
   destroyed(){
      //if( this.readyInterval != -1)
         clearInterval(this.readyInterval)
   },
   methods: {
      action4value(val){
         if(this.item.nc==val && this.item.nc!=0)
             this.nc=-1
         if(val!=-127 && this.item.nc!=val)
            this.nc=1
         if(val==-127 && this.nc==1){
            console.log("THIS.VALUE is need to be set to "+this.answer.min)
            this.$emit('change',this.answer.min)
         }
         if(val==-126)
            this.$emit('ismax',this.answer.max)

         
         
      },
      ncChange(e){
         console.log("NC: "+e)

         switch(e){
            case -1:
            console.log("NON CONOSCIUTO itemNC is "+this.item.nc)
            this.$emit('change', this.item.nc)
            break;

            case 1:
            console.log("CONOSCIUTO")
            let value = (this.value==this.item.nc) ? -127 : this.value
            this.action4value(value)
            break;

            default:
            console.log("NON RISPOSTO")
            this.$emit('change', -127)
         }

      },
      checkValue (e) {
         console.log('checkValue: '+e)
         console.log(e)
      },
      updateValue (e) {
         if(typeof e == 'object')
            e = this.value 
         console.log(this.value) 
         console.log("3 updateValue("+this.answer.max+") con e = "+e) 
         if(e>this.answer.max || e<this.answer.min){
            //this.$notify.error({title: 'Error',message: 'Il valore inserito ('+e+') non è valido, è superiore al massimo consentito ('+(this.answer.max)+')'});
            this.$emit('change',  e)
//            this.$notify.error({duration:5000,title: 'Errore ',message: })
            this.$alert('Il valore inserito alla domanda:<br /><strong>'+this.item.domanda+'</strong><br /> è fuori dal range!<br />è stato ripristinato il valore precedente!', "ERRORE", {dangerouslyUseHTMLString:true})
            setTimeout(() => {
               if(this.valueLast>this.answer.max || this.valueLast<this.answer.min)
                  this.valueLast = this.answer.min
               this.$emit('change',  this.valueLast)
            }, 100)
         }else{
            this.valueLast = e
            //console.log('updateValue: '+e)
            //this.onNCvalue = e
            this.$emit('change', e)
         }
      }
   },
   computed:{
      answer: function(){
         let answer = (typeof this.item.answer == 'string') ? JSON.parse(this.item.answer) : {min:0,max:100,precision:0,step:1}
         //answer.min=answer.min-answer.step
         //answer.max=answer.max+answer.step
         return answer

      },
      item:function(){
         let item = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)
         //if(item.nc==this.value)
           // this.nc=false
         return item
      }
  }
}
</script>
<style >
.el-form-item__content{
   margin-left:0 !important;
}.row.value-127 .el-input input::placeholder{color:#F73D3D !important;text-align:right;

}.row.value-9 .el-input input{color:#743001 !important;text-align:right;

}.row.range .el-select{width:calc(100% - 8px)
}.row.range .col.s12 .el-select{width:100%;
}.row.range .el-input input::placeholder{color:#F73D3D !important;text-align:right;

}.row.input .el-select{width:calc(100% - 8px)
}.row.input .col.s12 .el-select{width:100%;

}.row.select .el-select{width:100%;
}.row.select .el-select input::placeholder{color:#F73D3D !important;text-align:right;




}.row.value-ok .el-input{width:calc(100% - 8px);width:100%;

}

</style>